module.exports = __webpack_public_path__ + "img/logo-ui.2d21c377.png";